/* eslint-disable */
import React from 'react';
import { Ico } from './ShellIcons';
import { PORTAL_META, SECTION_DESC, ORDERS_WORLDS, fmtCount } from './portalMeta';
import sh from './shell.module.css';

// ============================================================
// PortalMegaMenu — the hover card under a portal tab: tile + name +
// description + "open" · the sections (three columns for the Orders worlds) ·
// a footer with the live status and the portal's primary action.
// Sections come from PORTAL_NAV.subsections (filtered by the same gates the
// header applies: adminOnly / miGated), Orders from ORDERS_WORLDS.
// ============================================================

export default function PortalMegaMenu({ portal, isActive, activeTab, devView, salesView, projectsView, ordersWorld, ordersSection, counts, onOpen, onSection, onOrders, onPrimary, isAdmin, canSeeMailIntel, status }) {
  const meta = PORTAL_META[portal.key] || { icon: 'folder', desc: '' };
  const isOrders = portal.key === 'orders';
  const subs = (portal.subsections || []).filter((s) => (!s.adminOnly || isAdmin) && (!s.miGated || canSeeMailIntel));
  const isCur = (s) => {
    if (!isActive) return false;
    if (s.devView) return devView === s.devView;
    if (s.salesView) return salesView === s.salesView;
    if (s.projectsView) return projectsView === s.projectsView;
    return activeTab === s.tab;
  };
  const sectionCount = (s) => (counts && counts[portal.key] && counts[portal.key][s.key] != null ? counts[portal.key][s.key] : null);
  return (
    <div className={`${sh.mega} ${isOrders ? sh.wide : ''}`} role="menu" aria-label={`${portal.label} sections`}>
      <div className={sh.megaHead}>
        <span className={sh.megaTile}><Ico name={meta.icon} /></span>
        <div className={sh.t}><div className={sh.megaNm}>{portal.label}</div><div className={sh.megaDs}>{meta.desc}</div></div>
        <button type="button" className={sh.megaOpen} onClick={(e) => { e.stopPropagation(); onOpen(); }} title={`Open ${portal.label}`} aria-label={`Open ${portal.label}`}><Ico name="arrow" /></button>
      </div>
      <div className={sh.megaBody}>
        {isOrders ? ORDERS_WORLDS.map((w) => (
          <div key={w.key} className={sh.megaGrp}>
            <div className={sh.megaGrpH}>{w.label}</div>
            {w.sections.map((s) => {
              const cur = isActive && ordersWorld === w.key && ordersSection === s.key;
              return (
                <button key={s.key} type="button" role="menuitem" className={`${sh.megaSec} ${cur ? sh.cur : ''}`} onClick={(e) => { e.stopPropagation(); onOrders(w.key, s.key); }}>
                  <span className={sh.sd} /><span className={sh.t}><span className={sh.n}>{s.label}</span>{s.d && <span className={sh.d}>{s.d}</span>}</span>
                </button>
              );
            })}
          </div>
        )) : (
          <div className={sh.megaGrp}>
            {subs.map((s) => {
              const k = sectionCount(s);
              const red = portal.key === 'qc' && s.key === 'managerReview' && k > 0;
              return (
                <button key={s.key} type="button" role="menuitem" className={`${sh.megaSec} ${isCur(s) ? sh.cur : ''}`} onClick={(e) => { e.stopPropagation(); onSection(s); }}>
                  <span className={sh.sd} />
                  <span className={sh.t}><span className={sh.n}>{s.richLabel === 'inout-selection' ? 'IN/OUT Selection' : s.label}</span>{SECTION_DESC[`${portal.key}.${s.key}`] && <span className={sh.d}>{SECTION_DESC[`${portal.key}.${s.key}`]}</span>}</span>
                  {k != null && <span className={`${sh.k} ${red ? sh.red : ''}`}>{fmtCount(k)}</span>}
                  {s.badge && <span className={sh.pill}>{s.badge}</span>}
                </button>
              );
            })}
            {subs.length === 0 && <div className={sh.megaGrpH}>Opens on its home</div>}
          </div>
        )}
      </div>
      <div className={sh.megaFoot}>
        <span className={sh.st}>{status && status.dot && <span className={`${sh.dot} ${sh[status.dot] || ''}`} />}{status ? status.text : 'Live'}</span>
        {meta.primary && onPrimary && <button type="button" className={sh.megaAct} onClick={(e) => { e.stopPropagation(); onPrimary(meta.primary.action); }}><Ico name="plus" />{meta.primary.label}</button>}
      </div>
    </div>
  );
}
